import { LazyRoute } from "@appretio/shared";
import { ErrorBoundary, semanticThemeTokens } from "@appretio/ui-kit";
import { lazy } from "react";
import { Outlet, type RouteObject } from "react-router-dom";

const InSeasonMarketingPage = lazy(() =>
  import("./inSeasonMarketingPage/InSeasonMarketingPage").then((m) => ({
    default: m.InSeasonMarketingPage
  }))
);

const ROOT = "marketing" as const;

const PATH = {
  IN_SEASON: "in-season"
} as const;

const LABEL = {
  ROOT: "Marketing",
  IN_SEASON: "In-Season"
} as const;

export const marketingRoutes: RouteObject = {
  path: ROOT,
  handle: {
    label: LABEL.ROOT,
    background: semanticThemeTokens.backgroundGradient[1]
  },
  element: <Outlet />,
  children: [
    {
      path: PATH.IN_SEASON,
      handle: {
        label: LABEL.IN_SEASON,
        background: semanticThemeTokens.backgroundGradient[2]
      },
      element: (
        <ErrorBoundary level="route">
          <LazyRoute>
            <InSeasonMarketingPage />
          </LazyRoute>
        </ErrorBoundary>
      )
    }
  ]
};
